import * as S from './HamburgerButton.styles';

const HamburgerButton = ({
	onClick,
	className,
}: {
	onClick: () => void;
	className?: string;
}) => {
	return (
		<S.HamburgerButtonHost
			type="button"
			className={className}
			onClick={onClick}
			aria-label="Obrir el menú"
		>
			<S.ButtonContainer>
				<S.ButtonStripe />
				<S.ButtonStripe />
				<S.ButtonStripe />
			</S.ButtonContainer>
		</S.HamburgerButtonHost>
	);
};

export default HamburgerButton;
